import PolicyPage from "./PolicyPage";
import { BRAND } from "@/branding.config";

export default function Cookies() {
  return (
    <PolicyPage title="Cookie Policy" description={`How ${BRAND.app_name} uses cookies and similar technologies.`}>
      <p>This policy explains how {BRAND.legal_company_name} uses cookies and similar
      technologies on {BRAND.website_url}.</p>
      <h2>Strictly necessary</h2>
      <p>These cookies are required to run the site: session tokens, CSRF protection, load
      balancer routing. They cannot be turned off.</p>
      <h2>Analytics</h2>
      <p>Aggregated, non-identifying analytics help us understand which features are used.
      You can opt out at any time from Settings → Privacy.</p>
      <h2>Preferences</h2>
      <p>Language, timezone and theme preferences are stored in a cookie so we can render
      the site in your chosen configuration.</p>
      <h2>Third-party cookies</h2>
      <p>We do not run third-party advertising cookies. Some marketing pages may set an
      analytics beacon (e.g. product analytics) which is anonymised and pseudonymised.</p>
      <h2>Contact</h2>
      <p>Questions? Email <a className="text-primary hover:underline" href={`mailto:${BRAND.support_email}`}>{BRAND.support_email}</a>.</p>
    </PolicyPage>
  );
}
